import { ResizeManager } from '@theme/event-manager';
import { debounce, minWidthQuery, createSlider, getObserver } from '@theme/theme-global';

if (!customElements.get('featured-products-tab')) {
  class FeaturedProducts extends HTMLDivElement {
    constructor() {
      super();
      this.section = this.closest('.shopify-section');
      this.sliderInstance = null;
      this._observer = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.sliderInstance || this._sliderInitializing) return;

      const isFirstSection = this.section && this.section.querySelector('[data-index]')?.dataset.index === '1';
      const assignSlider = () => {
        if (this.sliderInstance || this._sliderInitializing) return;
        this._sliderInitializing = true;
        createSlider(this, JSON.parse(this.dataset.params))
          .then((instance) => {
            this.sliderInstance = instance;
          })
          .finally(() => {
            this._sliderInitializing = false;
          });
      };

      if (isFirstSection) {
        assignSlider();
      } else if ('IntersectionObserver' in window) {
        this._observer = getObserver({ rootMargin: '300px 0px', threshold: 0 }, true, false);

        this._observer.observe(this, assignSlider);
      } else {
        // Fallback
        assignSlider();
      }
    }

    // Optional cleanup only when element is removed from DOM
    disconnectedCallback() {
      if (this._observer) {
        this._observer.unobserve(this);
        this._observer = null;
      }
    }
  }

  customElements.define('featured-products-tab', FeaturedProducts, {
    extends: 'div',
  });
}
